module.exports = __webpack_public_path__ + "img/youdao.30a743d.png";


//////////////////
// WEBPACK FOOTER
// ./static/youdao.png
// module id = Yk9q
// module chunks = 14